export const namespace = 'emailQuestion';